import {useCallback, useLayoutEffect, useState} from "react";

const useBodyScroll = (elementId) => {
  const [bodyScrollTop, setBodyScrollTop] = useState(0);

  const handleScroll = useCallback(
    (e) => {
      setBodyScrollTop(e.currentTarget.scrollTop);
    },
    [],
  );

  useLayoutEffect(() => {
    document.getElementById(elementId).addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [elementId, handleScroll]);

  return [bodyScrollTop, setBodyScrollTop];
}

export default useBodyScroll;